<template>
    <div>
            <v-container fluid>
                <v-layout class="mt-2">
                    <v-flex>
                        <v-text-field
                              name="search"
                                append-outer-icon="clear"
                                @click:append-outer="clear"
                                :loading="loading"
                                v-model="search"
                                class="ma-0"
                                flat
                                persistent-hint
                                :hint="getHint()"
                                @keyup.esc="search = null"
                                placeholder="Search on name, company, location"
                                append-icon="search"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container fluid>
                <v-layout class="mt-2 members-layout" v-if="items.length > 0">
                    <v-flex>
                        <div class="members-container" ref="wrap">
                            <v-list subheader three-line id="itemList">
                                <template v-for="(o, index) in items">
                                    <v-list-tile :key="o.member.email">
                                        <v-list-tile-content @click="onMemberClick(o)"
                                                             :title="`${o.member.first_name}'s details`">
                                            <v-list-tile-title>{{o.company.name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{o.address.town}}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title>{{`${o.member.first_name} ${o.member.last_name}`}}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn :href="`mailto:${o.member.email}`" target="_blank" icon title="Email"
                                                   :disabled="!o.member.email">
                                                <v-icon>email</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                        <v-list-tile-action>
                                            <v-btn :href="`tel:${o.member.direct_dial}`" target="_blank" icon
                                                   title="Direct Dial" :disabled="!o.member.direct_dial">
                                                <v-icon>phone</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                        <v-list-tile-action>
                                            <v-btn :href="`tel:${o.member.mobile}`" target="_blank" icon title="Mobile"
                                                   :disabled="!o.member.mobile">
                                                <v-icon>smartphone</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <v-divider class="mb-2 mt-2" :key="index" v-if="index < (items.length - 1)"></v-divider>
                                </template>
                            </v-list>
                            <mugen-scroll :handler="fetchData" :should-handle="!mugen" scroll-container="wrap">
                                <p class="text-xs-center">{{loadingText()}}</p>
                            </mugen-scroll>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
      <v-dialog v-model="dialog" fullscreen scrollable transition="dialog-bottom-transition">
        <v-card v-if="member">
          <v-card-title class="primary title text-uppercase white--text">Member Details</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-list two-line subheader>
              <v-subheader class="title text--primary">{{member.member.first_name}} {{member.member.last_name}}</v-subheader>
              <v-subheader class="subheading">{{member.company.name}}</v-subheader>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Sector</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.member.sector">{{ member.member.sector }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Email</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.member.email">{{member.member.email}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn :href="`mailto:${member.member.email}`" target="_blank" icon title="Email"
                         :disabled="!member.member.email">
                    <v-icon>email</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Direct Dial</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.member.direct_dial">{{member.member.direct_dial}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn :href="`tel:${member.member.direct_dial}`" target="_blank" icon
                         title="Direct Dial" :disabled="!member.member.direct_dial">
                    <v-icon>phone</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Mobile</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.member.mobile">{{member.member.mobile}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn :href="`tel:${member.member.mobile}`" target="_blank" icon title="Mobile"
                         :disabled="!member.member.mobile">
                    <v-icon>smartphone</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-list three-line subheader>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Address</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.address">
                    {{this.formattedAddress1(member.address)}}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title v-if="member.address">
                    {{this.formattedAddress2(member.address)}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn :href="this.googleMapUrl(member.address)" target="_blank" icon
                         title="Google Maps" :disabled="!member.address.post_code">
                    <v-icon>location_city</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Main Phone</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.address.telephone">{{member.address.telephone}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn :href="`tel:${member.address.telephone}`" target="_blank" icon title="Main Phone"
                         :disabled="!member.address.telephone">
                    <v-icon>phone</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Fax</v-list-tile-title>
                  <v-list-tile-sub-title v-if="member.address.fax">{{member.address.fax}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" flat @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import MemberService from '../services/member.service'
import Member from './../components/Member'
// import { mapGetters, mapActions } from 'vuex'
import { mapActions } from 'vuex'

export default {
  name: 'MembersSmall',
  components: { 'member': Member },
  props: {
    category: {
      default: 0,
      type: Number
    }
  },
  data: () => ({
    dialog: false,
    loading: false,
    total: 0,
    page: -1,
    items: [],
    search: null,
    mugen: false,
    fullyLoaded: false,
    member: null
  }),
  created () {
    this.debouncedSearch = this.lodash.debounce(this.remoteSearch, 1000, { 'leading': true })
    this.remoteSearch(null, 0)
  },
  computed: {
    // ...mapGetters(
    //   'member', {
    //     member: 'selectedMember'
    //   }
    // )
  },
  methods: {
    loadingText () {
      if (this.items.length === 0) {
        return 'No members found'
      }
      return (this.fullyLoaded) ? `${this.total} member${(this.total > 1) ? 's' : ''} loaded` : 'Load more ...'
    },
    fetchData () {
      if (!this.fullyLoaded) {
        this.remoteSearch(this.search, this.page + 1)
      }
    },
    // ...mapActions(
    //   'member', {
    //     setMember: 'setMember'
    //   }
    // ),
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    ),
    clear () {
      this.search = null
      this.total = 0
      this.page = -1
      this.items = []
      this.mugen = false
      this.remoteSearch(null, 0)
    },
    remoteSearch (val, page) {
      this.loading = true
      this.mugen = true
      MemberService.search({ q: val, c: this.category, page: page, size: 10 })
        .then(({ data, ...response }) => {
          this.total = data.total
          this.page = data.page
          if (page === 0) {
            this.resetScroll()
            this.items = data.hits
          } else {
            this.items = [...this.items, ...data.hits]
          }
        }).catch(e => {
          this.$log.error(e)
          this.items = []
          this.page = 0
          this.total = 0
        }).finally(() => {
          this.mugen = false
          this.loading = false
          this.fullyLoaded = this.total === this.items.length
        })
    },
    getHint () {
      if (this.items) {
        return `Showing ${this.total} member${this.total > 1 ? 's' : ''}`
      }
      return null
    },
    onMemberClick (o) {
      // this.setMember({ member: o })
      // this.$router.push({ name: 'member' })
      this.member = o
      this.dialog = true
    },
    resetScroll () {
      if (this.$refs.wrap) {
        this.$refs.wrap.scrollTop = 0
      }
    },
    formattedAddress1 (address) {
      let elements = []
      elements.push(address.address1)
      elements.push(address.address2)
      elements.push(address.address3)
      return elements.filter(e => e).join(', ')
    },
    formattedAddress2 (address) {
      let elements = []
      elements.push(address.town)
      elements.push(address.county)
      elements.push(address.post_code)
      return elements.filter(e => e).join(', ')
    },
    googleMapUrl (address) {
      if (address.post_code) {
        return `https://www.google.co.uk/maps/search/${address.post_code.replace(' ', '+')}`
      }
      return null
    }
  },
  watch: {
    category (newVal, oldVal) {
      this.clear()
    },
    search (val) {
      if (!val) {
        this.clear()
        return
      }

      if (val.length < 3) return

      this.debouncedSearch(val, 0)
    }
  }
}
</script>

<style scoped>

    .members-layout {
        max-height: calc(100vh - 200px);
    }

    .members-container {
        height: 100%;
        overflow-y: scroll;
        backface-visibility: hidden;
    }

</style>
